import React, {createRef, useMemo, useState} from "react";
import Question from "../../pretest/question";
import Headerback from "../../../component/headerback";


const defalutschema = {
  id: 1,
  desc: '概念篇',
  totalScore: 0,
  question: [
    {
      id: 1,
      desc: '以下关于山水诗的基础知识中，错误的一项是()',
      the_score: 0,
      options: [
        {
          label: '山水诗是只描写山水风景的诗，不涉及诗人情感的抒发。',
          value: '山水诗是只描写山水风景的诗，不涉及诗人情感的抒发。',
          score: 1,
          selected: false
        },
        {
          label: '山水诗的代表诗人有王维、孟浩然、韦应物、柳宗元。',
          value: '山水诗的代表诗人有王维、孟浩然、韦应物、柳宗元。',
          score: 0,
          selected: false
        },
        {
          label: '韦应物、柳宗元求新求变，实现山水诗从“无我之境”向“有我之境”的嬗变。',
          value: '韦应物、柳宗元求新求变，实现山水诗从“无我之境”向“有我之境”的嬗变。',
          score: 0,
          selected: false
        }
      ],
      selected: [

      ]
    }
  ]
}

window.localStorage.schema = JSON.stringify(defalutschema);

let a_schema;
try {
  a_schema = JSON.parse(window.localStorage.schema);
} catch { };

let refs = [];

export default function Partone() {
    const [schema, setSchema] = useState(a_schema);
    let { question, desc, outScore } = schema;
    const [finish, setFinish] = useState(false);
    const [finishScore, setFinishScore] = useState(0);
    const [disabled, setDisabled] = useState(false);

    let totalScore;

    let newSchema = {
        id: 1,
        totalScore: 0,
        question: [],
      };

    const handleSave = () => {
        document.getElementById("btn").setAttribute("disabled", true)
        document.getElementById("btn").onclick = "return false;";
        document.getElementById("btn").style.backgroundColor = "gray";
        document.getElementById("btn").style.cursor = "default";
        document.getElementById("btn").style.display="none";

        setFinish(true);
        totalScore = 0;
        schema.question.forEach((item, index) => {
          const { getSchema } = refs[index].current;
          newSchema.question.push(getSchema());
          if (getSchema().the_score) {
            totalScore += getSchema().the_score;
          }

        });
        newSchema.totalScore = totalScore;
        window.localStorage.schema = JSON.stringify(newSchema);
        setDisabled(true);
        setFinishScore(newSchema.totalScore);
        alert(`你本次答对${newSchema.totalScore}道题!\n 1、解析：山水诗可以表现自然山水之美，同时可以表达诗人观赏时的心境感受。“不涉及诗人情感的抒发”是错误的。所以A项错误。`)
      }

      useMemo(() => {
        refs = question.map(item => createRef());
      }, [question])


    return(
        <div>
            <Headerback
                showPage={1}
            />
            <div className="page course-page">
                 <div className="page-con">
                     <div className="partonefour">
                         <div className="problem-inner">
                             <p className="desc">{desc}</p>
                             {
                                 schema.question.map((item, index) => {
                                  return (
                                    <div key={item.id} className="question">
                                      <p className="title">{item.id}、{item.desc}</p>
                                       <Question finish={finish} item={item} ref={refs[index]} yanz={[2,1,1]}></Question>
                                    </div>)
                                })
                             }

                         </div>
                     </div>
                     <button className="miaov-btn miaov-btn-md problem-btn" type="submit" onClick={handleSave} id ='btn'>提交</button>
                 </div>
            </div>
        </div>
    )
}